import React, { useState } from 'react';
import { HStack,Box} from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import LeftFormSection from './LeftFromSection';
import RightSection from '../../Party/Right/RightSection';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import CustomerContent from './List'; // Import the Customer component

const CreateLedger = () => {
  const colors = useColors();

  const [isExpanded, setIsExpanded] = useState(false);

  // Toggle the expanded state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  

  return (
    <Box >
      <HeaderSection
        title="Create Ledger"
        breadcrumb={["Dashboard", "Accounts", "Create Ledger"]}
      />
      <HStack align="start" w="full" gap="0" mt={4} p={6}>
        <LeftFormSection

          colors={colors}
        />
        <RightSection
          isExpanded={isExpanded}
          toggleExpand={toggleExpand}
          colors={colors}
          content={CustomerContent} // Pass the Customer component
        />
      </HStack>
    </Box>
  );
};

export default CreateLedger;

